import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_content_block = _resolveComponent("content-block")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_ctx.isLoyaltyMember)
    ? (_openBlock(), _createBlock(_component_ion_row, {
        key: 0,
        size: "12",
        class: "rewards-container d-flex ion-justify-content-center",
        style: {"padding-top":"15px","background-color":"#f0efed"},
        "data-cy": "rewards-container"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "12",
            class: "ion-text-center py-0",
            "data-cy": "rewards-message"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_text, {
                class: "interstate-bold color-secondary",
                style: {"font-size":"1.2em"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Welcome" + _toDisplayString(_ctx.account.firstName ? `, ${_ctx.account.firstName}` : '') + "! ", 1)
                ]),
                _: 1
              }),
              (_ctx.isLoyaltyProcessing)
                ? (_openBlock(), _createBlock(_component_ion_text, {
                    key: 0,
                    class: "interstate-bold color-primary"
                  }, {
                    default: _withCtx(() => [
                      _cache[0] || (_cache[0] = _createTextVNode(" You have ")),
                      _createVNode(_component_ion_spinner, {
                        color: "primary",
                        name: "lines-small",
                        style: {"margin-bottom":"-8px"}
                      }),
                      _cache[1] || (_cache[1] = _createTextVNode(" Points."))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_text, {
                    key: 1,
                    class: "interstate-bold color-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" You have " + _toDisplayString(_ctx.pointsBalance) + " Points.", 1)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            size: "12",
            class: "d-flex ion-justify-content-center mb-8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_content_block, { slug: "home-page-rewards-banner" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "12",
            class: "d-flex ion-justify-content-center mb-8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_content_block, { slug: "home-page-nonmember-banner" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}